import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h2>Sorry, The page is not found!</h2>
            <p>Error 404 !!!</p>
        </div>
    );
};

export default NotFound;